// extracted by mini-css-extract-plugin
export default {"waveform":"oFFYH","time":"J04SC","isMyMessage":"hOXps","audio":"Qoc81","canvas":"UAnAf"};